export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const nuxtApp = useNuxtApp()
  nuxtApp.hook('app:mounted', () => {
    // window.newrelic は BrowserAgent の import 副作用でスタブだけ立つことがあり(truthy)、
    // エージェント未起動時は addRelease を持たない。存在チェックだけだと呼び出しで例外になるため、
    // addRelease が関数であることまで確認する(ローカル等でエージェント未起動なら何もせず終了する)。
    const newrelic = window.newrelic
    if (typeof newrelic?.addRelease !== 'function') {
      return
    }
    // Webアプリケーションのリリースバージョンをアプリケーション全体に対して一度だけNew Relicに通知する
    newrelic.addRelease(config.public.RELEASE_NAME, config.public.RELEASE_ID)
  })
})
